import { camelize, decamelize } from "humps";

export const getAttribute = <T extends Record<string, any>, K extends keyof T>(
  object: T | null | undefined,
  attribute: K
): T[K] | undefined => {
  if (!object) {
    return undefined;
  }
  const camelCaseAttribute = camelize(attribute as string);
  const snakeCaseAttribute = decamelize(attribute as string);

  if (snakeCaseAttribute === attribute) {
    return object[snakeCaseAttribute] ?? object[camelCaseAttribute];
  }

  return object[camelCaseAttribute] ?? object[snakeCaseAttribute];
};
